export default __webpack_public_path__ + "3a10ced99bbde1e29dd8391a6f7b67dc.png";